import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { WhyChooseSection } from '../components/WhyChooseSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function Landing() {
  return <main className="min-h-screen bg-white selection:bg-pastel-mint selection:text-slate-800 font-nunito" data-id="element-284">
      <Hero data-id="element-285" />
      <ProblemSection data-id="element-286" />
      <SolutionSection data-id="element-287" />
      <IncludesSection data-id="element-288" />
      <ComparisonSection data-id="element-289" />
      <WhyChooseSection data-id="element-290" />
      <TestimonialsSection data-id="element-291" />
      <FaqSection data-id="element-292" />
      <FinalCtaSection data-id="element-293" />
      <Footer data-id="element-294" />
      <PurchasePopup data-id="element-295" />
    </main>;
}